export default __webpack_public_path__ + "static/media/delete.825ece90.svg";